(ns frontend.view.settings2.permissions.events
  (:require
   [potpuri.core :as p]
   [re-frame.core :as rf]
   [frontend.view.settings2.permissions.sub :as sub]))

(defn reset-state!
  [{:keys [zadmin-state settings-state]}]
  (swap! zadmin-state {})
  (swap! settings-state {})
  ;; Deref possible cursors to make sure updates are synced
  (merge @zadmin-state @settings-state))

(rf/reg-event-fx
 ::select-entity-type
 (fn [{db :db} [_ entity-type]]
   {:db (assoc-in db [::sub/selected-entity-type] entity-type)}))

(rf/reg-event-fx
 ::open-create-dialog
 (fn [{db :db} [_]]
   {:db (-> db
            (assoc-in [::sub/create-dialog-status] :status/wip)
            (assoc-in [::sub/create-dialog-visible?] true))}))

(rf/reg-event-fx
 ::hide-create-dialog!
 (fn [{db :db} [_]]
   {:db (-> db
            (p/dissoc-in [::sub/create-dialog-visible?])
            (assoc-in [::sub/create-dialog-status] :status/hidden)
            (p/dissoc-in [::sub/new-field]))}))

(rf/reg-event-fx
 ::create-status!
 (fn [{db :db} [_ new-status]]
   {:db (assoc-in db [::sub/create-dialog-status] new-status)}))

(rf/reg-event-fx
 ::create-error
 (fn [{db :db} [_ err]]
   {:db (-> db
            (assoc-in [::sub/create-dialog-status] :status/error)
            (assoc-in [:sub/create-error] {:message err}))}))

(rf/reg-event-fx
 ::update-new-field
 (fn [{db :db} [_ attribute value]]
   {:db (-> db
            (assoc-in [::sub/new-field attribute] value))}))
